import Notes from 'src/components/Notes';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { getBgColor } from 'src/utils/icons';

const ReceiptNote = () => {
  const { isInProgress, updateFormData, receiptData, errors } = useReceiptDetails();
  return (
    <PopUp
      show={!!errors.notes.length}
      content={<PopUpContentWrapper contents={errors.notes} type="Error" />}
    >
      <div className={`p-1 ${getBgColor(errors.notes)}`}>
        <Notes
          notes={receiptData?.receiptNotes || ''}
          onChange={(value) => updateFormData('receiptNotes', value)}
          name={'Receipt'}
          disabled={!isInProgress}
          errors={errors.notes}
        />
      </div>
    </PopUp>
  );
};

export default ReceiptNote;
